var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { loadExperimentBudgetActionTypes, searchBudgetActionTypes, updateCurrentMGActionType } from "./SearchContainer.ducks.js";
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
import "../SearchFilters/SearchFilters.ducks.js";
import "../SearchFilters/SearchFilters.reducer.js";
const defaultReducerState = {
  experimentSearchParameters: null,
  numberlineUsages: getDefaultAsyncWrapperObj(),
  currentManagementGroup: ""
};
const reducer = (state = defaultReducerState, action) => {
  var _a, _b;
  switch (action.type) {
    case updateCurrentMGActionType:
      return __spreadProps(__spreadValues({}, state), {
        currentManagementGroup: action.payload
      });
    case searchBudgetActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        numberlineUsages: __spreadProps(__spreadValues({}, state.numberlineUsages), {
          status: AsyncRequestStatus.Pending
        })
      });
    case searchBudgetActionTypes.LOADED:
      const budgetResult = action;
      return __spreadProps(__spreadValues({}, state), {
        numberlineUsages: budgetResult.payload
      });
    case loadExperimentBudgetActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        numberlineUsages: __spreadProps(__spreadValues({}, state.numberlineUsages), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadExperimentBudgetActionTypes.LOADED:
      const expBudgetResult = action;
      return __spreadProps(__spreadValues({}, state), {
        experimentSearchParameters: ((_a = expBudgetResult.payload.data) == null ? void 0 : _a.SearchParameters) || null,
        numberlineUsages: {
          data: ((_b = expBudgetResult.payload.data) == null ? void 0 : _b.TrafficUsage) || null,
          error: expBudgetResult.payload.error,
          status: expBudgetResult.payload.status
        }
      });
    default:
      return state;
  }
};
export {
  reducer as default,
  defaultReducerState,
  reducer
};
//# sourceMappingURL=SearchContainer.reducer.js.map
